import { useSelector } from "react-redux";
import { useNavigation, isAdminSelector } from "h-commons";

import { ClosableModal } from "../../home/common/components/ClosableModal";
import { UPGRADE_URL_PATH } from "../../home/common/constants/constants";

const FeatureLimitExceededModal = ({ isOpen, closeModal, limits, featureName }) => {
    const { navigateTo } = useNavigation();
    const isAdmin = useSelector(isAdminSelector);
    if (!limits) return;
    const maxLimit = limits.total;

    const onCTAClick = () => {
        closeModal();
        navigateTo(UPGRADE_URL_PATH, true)
    }
  
    return (
      <ClosableModal 
        isOpen={isOpen}
        title={`Upgrade to create more ${featureName}`}
        description={`You’ve reached the maximum number of ${featureName} (${maxLimit}) allowed in the current plan. Upgrade your plan to increase the limit.`}
        btnText={'Upgrade'}
        showBtn={isAdmin}
        showIcons={true}
        onOk={onCTAClick}
        onClose={closeModal}
      />
    )
}

export default FeatureLimitExceededModal;